import * as React from "react";
import { Modal } from "react-bootstrap";
import { useForm } from "react-hook-form";
import { toast } from "react-toastify";
import { EditWebinarPostModel, ErrorResultModel, IEditWebinarPostModel, WebinarResponseModel } from "../../swagger-clients/s365-admin-panel-clients.service";
import LoadingService from "../../components/loading-indicator/loading-indicator.service";
import { getWebinarsClient } from "../../services/api-clients.service";
import UserTagParentSelect from "../../components/user-tag-parent-select/user-tag-parent-select.component";

interface IEditWebinarModalProps {
    webinarId: number;
    show: boolean;
    onSuccess: () => void;
    onHide: () => void;
}


const EditWebinarModal: React.FunctionComponent<IEditWebinarModalProps> = (props) => {


    const { control, register, handleSubmit, formState, getValues, setValue, watch } = useForm<IEditWebinarPostModel>();
    const [webinar, setWebinar] = React.useState<WebinarResponseModel>();
    const [isLoading, SetIsLoading] = React.useState<boolean>(false);

    React.useEffect(() => {

        if (props.webinarId) {
            getWebinar(props.webinarId);
        }

    }, [props.webinarId]);


    const getWebinar = async (webinarId: number) => {
        try {
            LoadingService.showLoading();
            const client = getWebinarsClient();
            const webinarResp = await client.getWebinar(webinarId);
            setWebinar(webinarResp);
            if (webinarResp) {
                setValue('userTag', webinarResp.userTag ?? "");
                setValue('userTagParentId', webinarResp.userTagParentId);
                setValue('userParticipantTagColor', webinarResp.userParticipantTagColor);
                setValue('userParticipantTagIcon', webinarResp.userParticipantTagIcon);
                setValue('userRegistrantTagColor', webinarResp.userRegistrantTagColor);
                setValue('userRegistrantTagIcon', webinarResp.userRegistrantTagIcon);
                setValue('addCommentToTP', webinarResp.addCommentToTP);
                setValue('isActive', webinarResp.isActive);

            }


        } catch (error) {
            console.log("An error occurred while getting organization.", error);
            toast.error("An error occurred while getting organization.");
        } finally {
            LoadingService.hideLoading();
        }
    }

    const onSubmit = async (data: IEditWebinarPostModel) => {

        try {
            SetIsLoading(true);

            const client = getWebinarsClient();
            await client.updateWebinar(props.webinarId, new EditWebinarPostModel(data));
            SetIsLoading(false);
            props.onSuccess();
            toast.success(`Webinar successfully updated.`);

        }
        catch (error) {
            console.log("An error occured while updating webinar.");
            const errorResultModel = error as ErrorResultModel;
            if (errorResultModel.errors && errorResultModel.errors.length > 0) {
                toast.error(errorResultModel.errors[0]);
            } else {
                toast.error("An error occured while updating updating.");
            }

            SetIsLoading(false);
        }
    }

    const userTagParentId= watch("userTagParentId");

    return <Modal
        show={props.show}
        onHide={props.onHide}
        animation={false}
    >
        <Modal.Header closeButton={true}>

            <Modal.Title>
                Edit webinar
            </Modal.Title>
        </Modal.Header>
        <form className="form" onSubmit={handleSubmit(onSubmit)}>
            <Modal.Body>
                <div className="form-group mb-2">
                    <label className="form-label">Name</label>
                    <input
                        className="form-control h-auto py-4 px-8"
                        style={{ marginBottom: "5px" }}
                        type="text"
                        placeholder="Name"
                        autoComplete={"false"}
                        value={webinar?.name}
                        readOnly
                    />
                </div>
                <div className="form-check mb-2">
                    <input className="form-check-input" type="checkbox"  {...register("addCommentToTP")} id="addCommentToTP" />
                    <label className="form-check-label" htmlFor="addCommentToTP">
                        Add comment to TP
                    </label>
                </div>
                <div className="form-check mb-2">
                    <input className="form-check-input" type="checkbox"  {...register("isActive")} id="isActive" />
                    <label className="form-check-label" htmlFor="isActive">
                       Enable
                    </label>
                </div>
                <div className="form-group mb-2">
                    <label className="form-label">User Tag</label>
                    <input
                        className="form-control h-auto py-4 px-8"
                        style={{ marginBottom: "5px" }}
                        type="text"
                        placeholder="User Tag"
                        autoComplete={"false"}
                        {...register("userTag", { required: true })}
                    />
                    {formState.errors && formState.errors.userTag && formState.errors.userTag.type === "required" && (<p className="text-danger">User tag is required!</p>)}
                </div>
                <div className="form-group mb-2">
                    <label className="form-label">User tag parent</label>
                    <UserTagParentSelect
                        {...register("userTagParentId", { required: true })}
                        value={userTagParentId}
                        onChange={(option) => { setValue("userTagParentId", option.value); }}
                    />
                    {formState.errors && formState.errors.userTagParentId && formState.errors.userTagParentId.type === "required" && (<p className="text-danger">User tag parent is required!</p>)}
                </div>

                <div className="form-group mb-2">
                    <label className="form-label">Participant tag color</label>
                    <input
                        className="form-control h-auto py-4 px-8"
                        style={{ marginBottom: "5px" }}
                        type="text"
                        placeholder="Participant tag color"
                        autoComplete={"false"}
                        {...register("userParticipantTagColor")}
                    />
                </div>
                <div className="form-group mb-2">
                    <label className="form-label">Participant tag icon</label>
                    <input
                        className="form-control h-auto py-4 px-8"
                        style={{ marginBottom: "5px" }}
                        type="text"
                        placeholder="Participant tag icon"
                        autoComplete={"false"}
                        {...register("userParticipantTagColor")}
                    />
                </div>
                <div className="form-group mb-2">
                    <label className="form-label">Registrant tag color</label>
                    <input
                        className="form-control h-auto py-4 px-8"
                        style={{ marginBottom: "5px" }}
                        type="text"
                        placeholder="Registrant tag color"
                        autoComplete={"false"}
                        {...register("userRegistrantTagColor")}
                    />
                </div>
                <div className="form-group mb-2">
                    <label className="form-label">Registrant tag icon</label>
                    <input
                        className="form-control h-auto py-4 px-8"
                        style={{ marginBottom: "5px" }}
                        type="text"
                        placeholder="Registrant tag icon"
                        autoComplete={"false"}
                        {...register("userRegistrantTagIcon")}
                    />
                </div>


            </Modal.Body>

            <Modal.Footer>
                <div className="form-group d-flex float-right">
                    <button type="submit" className={'btn btn-primary'} disabled={isLoading}>
                        {isLoading && <span className="spinner-border spinner-border-sm mr-2" role="status" aria-hidden="true"></span>}
                        Save
                    </button>
                    <button type="button" onClick={props.onHide} className={'btn btn-danger ml-2'} disabled={isLoading}>
                        Cancel
                    </button>

                </div>
            </Modal.Footer>
        </form>
    </Modal>


}

export default EditWebinarModal;